export const styles = {
  container:
    'tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full tw-p-8 tw-text-center',
  icon: 'tw-text-danger-500 tw-text-5xl tw-mb-4',
  title: 'tw-text-2xl tw-font-bold tw-text-neutral-800 tw-mb-2',
  message: 'tw-text-neutral-600 tw-mb-6 tw-max-w-lg',
  actions: 'tw-flex tw-items-center tw-gap-3 tw-mb-6',
  detailsContainer: 'tw-w-full tw-max-w-3xl tw-text-left',
  detailsHeader: 'tw-flex tw-items-center tw-justify-between tw-mb-2',
  detailsLabel: 'tw-text-xs tw-font-bold tw-text-neutral-500 tw-uppercase tw-tracking-wider',
  errorBlock:
    'tw-w-full tw-bg-neutral-50 tw-border tw-border-neutral-200 tw-rounded tw-p-4 tw-overflow-auto tw-max-h-[400px]',
  errorName: 'tw-text-danger-600 tw-font-bold tw-text-sm tw-mb-1',
  errorMessage: 'tw-text-neutral-800 tw-text-sm tw-mb-3',
  stackTrace:
    'tw-text-xs tw-font-mono tw-text-neutral-600 tw-whitespace-pre-wrap tw-leading-relaxed',
  componentStack: 'tw-mt-4 tw-pt-4 tw-border-t tw-border-neutral-200',
  componentStackLabel:
    'tw-text-xs tw-font-bold tw-text-neutral-500 tw-uppercase tw-tracking-wider tw-mb-2',
};
